
import { defineComponent, ref, watch, onMounted } from 'vue'
import { stockpool } from '@/api/index'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'DragonSignalBacktest',
  props: {
    theme: {
      type: String,
      default: 'light'
    },
    signalType: {
      type: String,
      default: 'dragon_signal_sprint' // dragon_signal_sprint 冲刺, dragon_signal_ignition 点火
    }
  },
  setup(props) {
    const route = useRoute()
    const periodData = ref([
      { type: 30, label: '近1月', data: null as any },
      { type: 90, label: '近3月', data: null as any },
      { type: 365, label: '近1年', data: null as any }
    ])

    const fetchData = async () => {
      const signal = props.signalType === 'dragon_signal_sprint' ? 1 : 2
      
      try {
        const promises = periodData.value.map(item => {
          return stockpool.getDragonSignalTracking({
            data: {
              signal,
              timeType: item.type
            },
            headers: {
              clienttype: 'pc',
              appVersion: route.query.appVersion,
              token: route.query.token
            }
          })
        })
        
        const results = await Promise.all(promises)
        
        periodData.value.forEach((item, index) => {
          const res = results[index] as any
          if (res && res.data) {
            item.data = res.data || {}
          }
        })
      } catch (error) {
        console.error('Fetch backtest data failed', error)
      }
    }

    watch(() => props.signalType, () => {
      fetchData()
    })

    onMounted(() => {
      fetchData()
    })

    const formatPercent = (val: number | null | undefined) => {
      if (val === null || val === undefined) return '--'
      return (val * 100).toFixed(2) + '%'
    }

    const getColorClass = (val: number | null | undefined) => {
      if (val === null || val === undefined || val === 0) return 'color-gray'
      return val > 0 ? 'color-red' : 'color-green'
    }

    return {
      periodData,
      formatPercent,
      getColorClass
    }
  }
})
